/**
 * 仓库
 */
import { makeAutoObservable, runInAction } from 'mobx'
import RepositoryApi from '@api/mallRepository.api'

export enum TERuleType {
  city = 'city',
  commodity = 'commodity',
}

class Repository {
  constructor () {
    makeAutoObservable(this)
  }

  // 初始化标记
  isInit: boolean = false

  // 仓库列表
  respList = [] as IRepository[]

  // 仓库信息
  info: IRepository = {
    mallRepositoryId: 0,
    repositoryName: '',
    senderAddress: '',
    senderAddressDetail: '',
    senderName: '',
    tel: '',
    expressConfig: '0',
    returnAddress: '',
    returnAddressDetail: '',
    returnIntro: '',
    addUser: '',
    modifyUser: '',
    contextId: 0,
    sysAddTime: '',
    sysModifyTime: '',
    addTime: '',
    modifyTime: '',
    isDel: 0,
    remark: null,
    pic: null,
    expressFeeRuleDTOList: [],
  }

  /** productNo: fee 类型输出 */
  get expressFeeForProductNoMap () {
    let map = {} as { [key: string]: any }
    (this.info?.expressFeeRuleDTOList || []).forEach((item) => {
      let cityFee = item.ruleType === TERuleType.commodity ? [{ city: 'ALL', fee: item.fee * 1 }] : item.expressCityFeeDTOS
      item.expressProductFeeDTOS?.forEach((prod) => {
        map[prod.productNo] = cityFee
      })
    })
    return map
  }

  /** 初始化 */
  async init () {
    if (this.isInit) return
    const res = await this.getRepositoryData()
    runInAction(() => {
      this.isInit = true
    })
    return res
  }

  /** 获取仓库数据 */
  async getRepositoryData () {
    try {
      const res: any = await RepositoryApi.list()
      runInAction(() => {
        this.respList = res.result
        if (res.result?.length) {
          this.info = res.result?.[0]
        }
      })
      return res
    } catch (err: any) {
      // throw err
      return Promise.reject(err?.message)
    }
  }

  /**
   * 计算运费 用户省市/商品
   * @param productNos 购物车商品no
   * @param extra 当前用户所在省市code
   */
  calcExpressFeeForProd (productNos: string[] = [], extra: { cityCode: string; provinceCode: string; countyCode: string }) {
    let feeNomal = parseFloat(this.info?.expressConfig || '0')
    let feeBest = -1
    const mapProd = this.expressFeeForProductNoMap
    productNos.forEach((no) => {
      // 当前商品是否击中特殊运费地区
      let isMatch = false
      // 同一个商品，在不同地区方案内的最佳运费
      let feeCity = 0
      mapProd[no]?.forEach(({ city, fee }) => {
        if ((city === 'ALL' || (!!extra?.cityCode && city.indexOf(extra?.cityCode || '') > -1) || (!!extra?.provinceCode && city.indexOf(extra?.provinceCode || '') > -1) || (!!extra?.countyCode && city.indexOf(extra?.countyCode || '') > -1)) && fee >= feeBest) {
          fee >= feeCity && (feeCity = fee)
          isMatch = true
        }
      })
      // 没有击中特殊运费按照统一运费处理
      !isMatch && (feeCity = feeNomal)
      feeCity >= feeBest && (feeBest = feeCity)
    })
    return feeBest >= 0 ? feeBest : feeNomal
  }
}

export default new Repository()
